import { useState, useEffect } from "react";
import { Trophy, Crown, Target, CalendarCheck, Award } from "lucide-react";
import { useFb, formatMatchDay } from "../../utils/football";

const StatCard = ({ icon: Icon, label, value, sub }) => (
  <div className="rounded-xl border border-amber-400/20 bg-slate-900/50 p-4 text-center" data-testid={`fb-profile-stat-${label.toLowerCase().replace(/ /g, "-")}`}>
    <Icon size={18} className="mx-auto mb-1 text-amber-400" />
    <div className="text-2xl font-extrabold text-amber-400">{value}</div>
    <div className="text-[11px] text-slate-400">{label}</div>
    {sub && <div className="text-[10px] text-slate-500">{sub}</div>}
  </div>
);

export default function FootballProfileStats() {
  const fb = useFb();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setStats(await fb.get("/football/profile/stats")); } catch {}
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="mb-6 h-44 animate-pulse rounded-xl bg-slate-800/50" />;

  const s = stats || {};
  const pred = s.predictor || {};
  return (
    <div className="mb-6" data-testid="football-profile-stats">
      <div className="mb-3 flex items-center gap-2">
        <Trophy size={18} className="text-amber-400" />
        <h3 className="text-md font-semibold text-amber-400">Football World Cup 2026</h3>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <StatCard icon={Trophy} label="Total Points" value={s.total_points ?? 0} sub={s.overall_rank ? `Rank #${s.overall_rank}` : "Unranked"} />
        <StatCard icon={CalendarCheck} label="Match Days" value={s.match_days_played ?? 0} />
        <StatCard icon={Crown} label="Manager of Day" value={s.manager_of_day_count ?? 0} />
        <StatCard icon={Target} label="Predictor Acc." value={`${pred.accuracy ?? 0}%`} sub={`${pred.correct ?? 0}/${pred.answered ?? 0} correct`} />
      </div>
      {s.best_match_day && (
        <div className="mt-3 flex items-center justify-between rounded-xl border border-amber-400/20 bg-slate-900/50 p-3" data-testid="fb-profile-best-day">
          <span className="flex items-center gap-2 text-sm text-slate-300"><Award size={16} className="text-amber-400" /> Best Match Day · {formatMatchDay(s.best_match_day.match_day)}</span>
          <span className="font-extrabold text-amber-400">{s.best_match_day.points} pts</span>
        </div>
      )}
    </div>
  );
}
